<h2 mat-dialog-title>
  <div>
    <span *ngIf="product">Modifica Prodotto: {{ product.name }}</span>
    <span *ngIf="!product">Nuovo Prodotto</span>
  </div>
</h2>

<mat-dialog-content>
  <form [formGroup]="productForm" novalidate>
    <mat-error *ngIf="!product && productForm.get('photo').hasError('required')" style="text-align: center;">Immagine obbligatoria</mat-error>
    <div class="avatar-upload">
      <div class="avatar-edit">
        <input type="file" (change)="onFileSelected($event)" id="imageUpload" accept=".png, .jpg, .jpeg" />
        <label for="imageUpload"></label>
      </div>
      <div class="avatar-preview">
        <div id="imagePreview" style="background-image: url(../../../../../../../assets/images/no-image.jpg);">
        </div>
      </div>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Nome Prodotto</mat-label>
        <input matInput formControlName="name" placeholder="Nome Prodotto" required>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Prezzo</mat-label>
        <input type="number" matInput formControlName="price" min="0" step="0.5" placeholder="Prezzo" required>
        <span matSuffix>€</span>
      </mat-form-field>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Tipologia</mat-label>
        <mat-select formControlName="type">
          <mat-option *ngFor="let type of types" [value]="type.value">
            {{ type.displayWith }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="u-full-width">
        <mat-label>Famiglia</mat-label>
        <input matInput formControlName="family" readonly>
      </mat-form-field>
      
      
      
    </div>

    <div class="u-flex-full">
      <mat-checkbox color="primary" formControlName="editable">Soggetto a variazioni</mat-checkbox>
    </div>

    <div class="u-flex-full">
      <mat-form-field class="u-full-width">
        <mat-label>Descrizione</mat-label>
        <textarea matInput formControlName="description" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="2" cdkAutosizeMaxRows="5" placeholder="Descrizione"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="left-actions">
    <button mat-raised-button  type="button" (click)="resetForm()"
      [disabled]="productForm.pristine">
      Reset
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()"
      [disabled]="productForm.pristine || !productForm.valid">
      Salva
    </button>
  </div>
  <div>
    <button mat-raised-button type="button" (click)="cancel()">
      Chiudi
    </button>
  </div>
</mat-dialog-actions>

<!-- <div class="footer" *ngIf="loading$ | async">
  <div class="spinner">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
  </div>
</div> -->
